const handleRegionEvent = (container, item) => {
  const parent = item.closest('[data-region]');
  if (!parent) return;

  const region = parent.getAttribute('data-region');

  container.querySelectorAll('.is-active').forEach((el) => {
    el.classList.remove('is-active');
  });

  container.querySelectorAll(`[data-region="${region}"]`).forEach((el) => {
    el.classList.add('is-active');
  });

  container.querySelector(`.map-infographic__texts .${region}`).classList.add('is-active');
};

document.querySelectorAll('.map-infographic').forEach((el) => {
  const regions = el.querySelectorAll('[data-region]');

  regions.forEach((item) => {
    if (isTouchDevice) {
      item.addEventListener('click', () => handleRegionEvent(el, item));
    } else {
      item.addEventListener('mouseover', () => handleRegionEvent(el, item));
    }
  });
});
